<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="资产类型">
              <el-radio-group v-model="where.asset_type" size="small" class="ele-block" @change="reload">
                <el-radio-button
                  v-for="item in assetTypeOptions"
                  :key="item.value"
                  :label="item.value">
                  {{ item.label }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="用户名称">
              <el-input clearable v-model.trim="where.username" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="用户昵称">
              <el-input clearable v-model.trim="where.nickname" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="商户ID">
              <el-input clearable v-model.trim="where.mch_id" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div class="balance-stat-bar">
        <span v-if="stats.currency_code">币种: {{ stats.currency_code }}</span>
        <span>可用余额: {{ stats.balance }}</span>
        <span>实际余额: {{ stats.sj_balance }}</span>
        <span>冻结余额: {{ stats.blockedbalance }}</span>
        <span>未结算: {{ stats.no_balance }}</span>
        <span>总余额: {{ stats.sum_balance }}</span>
        <span>昨日余额: {{ stats.yesterday_balance }}</span>
      </div>

      <el-alert
        v-if="where.asset_type === 'virtual'"
        title="虚拟币分账尚未启用，当前无虚拟币余额数据"
        type="info"
        :closable="false"
        show-icon
        class="balance-alert" />

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        height="calc(100vh - 330px)">
        <template slot="action" slot-scope="{ row }">
          <el-button size="mini" type="primary" class="ele-btn-icon" @click="openDetail(row)">详情</el-button>
          <el-button size="mini" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:index:edit')">编辑</el-button>
        </template>
      </ele-pro-table>
    </el-card>

    <balance-detail :data="current" :visible.sync="showDetail" />
    <user-edit :data="current" :asset-type="where.asset_type" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { loadDictOptions } from '@/utils/dict';
import UserEdit from './user-edit';
import BalanceDetail from './balance-detail';

const EMPTY_STATS = {
  balance: '0.00',
  sj_balance: '0.00',
  blockedbalance: '0.00',
  no_balance: '0.00',
  sum_balance: '0.00',
  yesterday_balance: '0.00',
  currency_code: ''
};

const COLUMNS = [
  { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
  { prop: 'username', label: '用户名称', align: 'center', showOverflowTooltip: true, minWidth: 110, fixed: 'left' },
  { prop: 'nickname', label: '用户昵称', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { prop: 'mch_id', label: '商户ID', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { prop: 'balance', label: '可用余额', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { prop: 'sj_balance', label: '实际余额', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { prop: 'blockedbalance', label: '冻结余额', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { prop: 'no_balance', label: '未结算', align: 'center', showOverflowTooltip: true, minWidth: 100 },
  { prop: 'sum_balance', label: '总余额', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { prop: 'yesterday_balance', label: '昨日余额', align: 'center', showOverflowTooltip: true, minWidth: 110 },
  { columnKey: 'action', label: '操作', width: 140, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
];

export default {
  name: 'BalanceIndex',
  components: { UserEdit, BalanceDetail },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/user/getbalance',
      columns: COLUMNS,
      where: { asset_type: 'fiat', username: '', nickname: '', mch_id: '' },
      assetTypeOptions: [],
      stats: { ...EMPTY_STATS },
      current: null,
      showDetail: false,
      showEdit: false
    };
  },
  mounted() {
    loadDictOptions('asset_type')
      .then((list) => { this.assetTypeOptions = list || []; })
      .catch((e) => this.$message.error(e.message));
    this.loadStats();
  },
  methods: {
    reload() {
      if (this.$refs.table) {
        this.$refs.table.reload({ where: this.where });
      }
      this.loadStats();
    },
    reset() {
      this.where = {
        asset_type: this.where.asset_type || 'fiat',
        username: '',
        nickname: '',
        mch_id: ''
      };
      this.reload();
    },
    loadStats() {
      this.$http
        .get('/user/getBalanceCount', { params: { asset_type: this.where.asset_type } })
        .then((res) => {
          if (res.data.code === 0) {
            this.stats = Object.assign({}, EMPTY_STATS, res.data.data || {});
            return;
          }
          this.$message.error(res.data.msg);
        })
        .catch((e) => this.$message.error(e.message));
    },
    openDetail(row) {
      this.current = row;
      this.showDetail = true;
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    }
  }
};
</script>

<style scoped>
.balance-stat-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 28px;
  margin-bottom: 12px;
  padding: 10px 16px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.balance-alert {
  margin-bottom: 12px;
}
</style>
